import Vue from 'vue'
import Router from 'vue-router'
import {getNowCookie} from 'utils/commonBase';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条 样式

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      redirect: {
        name: 'index'
      }
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        name: '登录'
      },
      component: resolve => require(['views/login/login'], resolve)
    },
    {
      path: '/pages',
      name: 'index',
      meta: {
        name: '首页',
        requestAuth: true
      },
      component: resolve => require(['views/pages/pages'], resolve),
      redirect: {
        name: 'homepage'
      },
      children: [
        {
          path: 'homepage',
          name: 'homepage',
          meta: {
            name: '主页',
            requestAuth: true
          },
          component: resolve => require(['views/pages/homepage/homepage'], resolve)
        },
        {
          // 客服中心
          path: 'callCenter',
          name: 'callCenter',
          title: '客服中心',
          meta: {
            requestAuth: true,
            breadTitle: '客服中心',
          },
          redirect: {
            name: 'callCenterIndex'
          },
          component: resolve => require(['views/pages/callCenter/index'], resolve),
          children: [
            {
              path: 'callCenterIndex',
              name: 'callCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'callCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'callCenterIndex',
              name: 'callCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'callCenter',
                pageFlag: 1 // 判断是不是对应中心的首页
              },
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'afterSalesManager',
              name: 'afterSalesManager',
              meta: {
                name: '售后管理',
                requestAuth: true
              },
              redirect: {
                name: 'callCenterIndex'
              },
              component: resolve => require(['views/pages/callCenter/afterSalesManager/index'], resolve),
              children: [
                {
                  path: 'afterSalesList',
                  name: 'afterSalesList',
                  title: '售后单列表',
                  meta: {
                    name: '售后单列表',
                    requestAuth: true,
                    acKey: 'callCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/callCenter/afterSalesManager/afterSalesList/afterSalesList'], resolve)
                },
                {
                  path: 'particulars',
                  name: 'particulars',
                  title: '查看售后单详情',
                  meta: {
                    name: '查看售后单详情',
                    level: 3,
                    requestAuth: true,
                    acKey: 'callCenter'
                  },
                  component: resolve => require(['views/pages/callCenter/afterSalesManager/afterSalesList/particulars'], resolve)
                },
              ]
            },
          ]
        },
        {
          path: 'proCenter',
          name: 'proCenter',
          meta: {
            name: '商品中心',
            requestAuth: true
          },
          redirect: {
            name: 'proCenterIndex'
          },
          component: resolve => require(['views/pages/proCenter/index'], resolve),
          children: [
            {
              path: 'proCenterIndex',
              name: 'proCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'proCenter',
                pageFlag: 1 // 判断是不是对应中心的首页
              },
              // component: resolve => require(['views/pages/proCenter/proCenterIndex/proCenterIndex'], resolve)
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'baseSet',
              name: 'baseSet',
              meta: {
                name: '基础设置',
                requestAuth: true
              },
              redirect: {
                name: 'proCenterIndex'
              },
              component: resolve => require(['views/pages/proCenter/baseSet/index'], resolve),
              children: [
                {
                  path: 'categoryList',
                  name: 'categoryList',
                  meta: {
                    name: '商品分类',
                    requestAuth: true,
                    acKey: 'proCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/proCenter/baseSet/categoryList/categoryList'], resolve)
                },
                {
                  path: 'brandList',
                  name: 'brandList',
                  meta: {
                    requestAuth: true,
                    name: '商品品牌'
                  },
                  redirect: {
                    name: 'brandLists'
                  },
                  component: resolve => require(['views/pages/proCenter/baseSet/brandList/index'], resolve),
                  children: [
                    {
                      path: 'brandLists',
                      name: 'brandLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/brandList/brandList'], resolve)
                    },
                    {
                      path: 'addNewbrand',
                      name: 'addNewbrand',
                      meta: {
                        name: '新增品牌',
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/brandList/addNewbrand'], resolve)
                    },
                    {
                      path: 'modifybrand',
                      name: 'modifybrand',
                      meta: {
                        name: '修改品牌',
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/brandList/modifybrand'], resolve)
                    }
                  ]
                },
                {
                  path: 'proPropertyList',
                  name: 'proPropertyList',
                  meta: {
                    requestAuth: true,
                    name: '商品属性'
                  },
                  redirect: {
                    name: 'basisExtends'
                  },
                  component: resolve => require(['views/pages/proCenter/baseSet/proPropertyList/index'], resolve),
                  children: [
                    {
                      path: 'basisExtend',
                      name: 'basisExtend',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      redirect: {
                        name: 'basisExtends'
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/proPropertyList/basisExtend/index'], resolve),
                      children: [
                        {
                          path: 'basisExtends',
                          name: 'basisExtends',
                          meta: {
                            requestAuth: true,
                            acKey: 'proCenter',
                            level: 3
                          },
                          component: resolve => require(['views/pages/proCenter/baseSet/proPropertyList/basisExtend/basisExtends'], resolve)
                        },
                        {
                          path: 'addnewAttribute',
                          name: 'addnewAttribute',
                          meta: {
                            name: '新增属性',
                            requestAuth: true,
                            acKey: 'proCenter',
                            level: 3
                          },
                          component: resolve => require(['views/pages/proCenter/baseSet/proPropertyList/basisExtend/addnewAttribute'], resolve)
                        },
                        {
                          path: 'modifyAttribute',
                          name: 'modifyAttribute',
                          meta: {
                            name: '修改属性',
                            requestAuth: true,
                            acKey: 'proCenter',
                            level: 3
                          },
                          component: resolve => require(['views/pages/proCenter/baseSet/proPropertyList/basisExtend/modifyAttribute'], resolve)
                        }
                      ]
                    }
                  ]
                },
                {
                  path: 'materialList',
                  name: 'materialList',
                  meta: {
                    requestAuth: true,
                    name: '商品材质'
                  },
                  redirect: {
                    name: 'materialLists'
                  },
                  component: resolve => require(['views/pages/proCenter/baseSet/materialList/index'], resolve),
                  children: [
                    {
                      path: 'materialLists',
                      name: 'materialLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/materialList/materialList'], resolve)
                    },
                    {
                      path: 'addNewmaterial',
                      name: 'addNewmaterial',
                      meta: {
                        name: '新增材质',
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/materialList/addNewmaterial'], resolve)
                    },
                    {
                      path: 'modifymaterial',
                      name: 'modifymaterial',
                      meta: {
                        name: '修改材质',
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/baseSet/materialList/modifymaterial'], resolve)
                    }
                  ]
                },
              ]
            },
            {
              path: 'stockSet',
              name: 'stockSet',
              meta: {
                name: '库存管理',
                requestAuth: true
              },
              redirect: {
                name: 'proCenterIndex'
              },
              component: resolve => require(['views/pages/proCenter/stockSet/index'], resolve),
              children: [
                {
                  path: 'stockList',
                  name: 'stockList',
                  meta: {
                    name: '库存监控',
                    requestAuth: true,
                  },
                  component: resolve => require(['views/pages/proCenter/stockSet/stockList/stockList'], resolve)
                }, {
                  path: 'stockCartList',
                  name: 'stockCartList',
                  meta: {
                    name: '购物车监控',
                    requestAuth: true,
                  },
                  component: resolve => require(['views/pages/proCenter/stockSet/stockCartList/stockCartList'], resolve)
                },
                {
                  path: 'stockInBill',
                  name: 'stockInBill',
                  meta: {
                    requestAuth: true,
                    name: '入库单管理'
                  },
                  redirect: {
                    name: 'stockInBills'
                  },
                  component: resolve => require(['views/pages/proCenter/stockSet/stockInBill/index'], resolve),
                  children: [
                    {
                      path: 'stockInBills',
                      name: 'stockInBills',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/stockSet/stockInBill/stockInBillList'], resolve)
                    },
                    {
                      path: 'stockInBillAdd',
                      name: 'stockInBillAdd',
                      meta: {
                        name: '新增入库单',
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/stockSet/stockInBill/stockInBillAdd'], resolve)
                    },
                    {
                      path: 'stockInBillView',
                      name: 'stockInBillView',
                      meta: {
                        name: '查看入库单',
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/stockSet/stockInBill/stockInBillView'], resolve)
                    }
                  ]
                },

              ]
            },

            {
              path: 'proManager',
              name: 'proManager',
              meta: {
                name: '商品管理',
                requestAuth: true
              },
              redirect: {
                name: 'proCenterIndex'
              },
              component: resolve => require(['views/pages/proCenter/proManager/index'], resolve),
              children: [
                {
                  path: 'table-look-up',
                  name: 'table-look-up',
                  meta: {
                    name: '商品一览表',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'table-look-ups'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/table-look-up/index'], resolve),
                  children: [
                    {
                      path: 'table-look-ups',
                      name: 'table-look-ups',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/table-look-up/table-look-up'], resolve)
                    },
                    {
                      path: 'tableupsauditeddetai',
                      name: 'tableupsauditeddetai',
                      meta: {
                        name: '商品详情',
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/table-look-up/auditdetails'], resolve)
                    }
                  ]
                },
                {
                  // 商品管理
                  path: 'proRelease',
                  name: 'proRelease',
                  title: '发布商品',
                  meta: {
                    breadTitle: '发布商品',
                    breadTopTitle: '商品管理',
                    requestAuth: true,
                    acKey: 'proCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/proCenter/proRelease/proRelease'], resolve)
                },
                {
                  path: 'proReleaseEditor/:type/:proSpu',
                  name: 'proReleaseEditor',
                  title: '编辑商品',
                  meta: {
                    breadTitle: '编辑商品',
                    breadTopTitle: '编辑商品',
                    level: 3,
                    requestAuth: true,
                    acKey: 'proCenter'
                  },
                  component: resolve => require(['views/pages/proCenter/proRelease/proReleaseEditor'], resolve)
                },
                {
                  path: 'recycleBin',
                  name: 'recycleBin',
                  title: '回收站',
                  meta: {
                    breadTitle: '回收站',
                    level: 3,
                    requestAuth: true,
                    acKey: 'proCenter'
                  },
                  component: resolve => require(['views/pages/proCenter/proRelease/recycleBin'], resolve)
                },
                {
                  path: 'methodofprice',
                  name: 'methodofprice',
                  meta: {
                    acKey: 'logisticsCenter',
                    name: '选择运费模版',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/proCenter/proRelease/methodofprice'], resolve),
                },
                {
                  path: 'sysProList',
                  name: 'sysProList',
                  meta: {
                    name: '系统商品',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'sysProLists'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/sysProList/index'], resolve),
                  children: [
                    {
                      path: 'sysProLists',
                      name: 'sysProLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/sysProList/sysProList'], resolve)
                    },
                    {
                      path: 'editorsys/:type/:proSpu',
                      name: 'editorsys',
                      meta: {
                        name: '系统商品编辑',
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/sysProList/editorsys'], resolve)
                    }
                  ]
                },
                {
                  path: 'checkPendingList',
                  name: 'checkPendingList',
                  meta: {
                    requestAuth: true,
                    name: '待审核商品'
                  },
                  redirect: {
                    name: 'checkPendingLists'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/checkPendingList/index'], resolve),
                  children: [
                    {
                      path: 'checkPendingLists',
                      name: 'checkPendingLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/checkPendingList/checkPendingList'], resolve)
                    },
                    {
                      path: 'checkpenddetail',
                      name: 'checkpenddetail',
                      meta: {
                        name: '审核详情',
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/checkPendingList/auditdetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'auditedList',
                  name: 'auditedList',
                  meta: {
                    name: '已审核商品',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'auditedLists'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/auditedList/index'], resolve),
                  children: [
                    {
                      path: 'auditedLists',
                      name: 'auditedLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/auditedList/auditedList'], resolve)
                    },
                    {
                      path: 'auditeddetai',
                      name: 'auditeddetai',
                      meta: {
                        name: '审核详情',
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/auditedList/auditdetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'rejectedList',
                  name: 'rejectedList',
                  meta: {
                    name: '已驳回商品',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'rejectedLists'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/rejectedList/index'], resolve),
                  children: [
                    {
                      path: 'rejectedLists',
                      name: 'rejectedLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/rejectedList/rejectedList'], resolve)
                    },
                    {
                      path: 'rejectuditdetails',
                      name: 'rejectuditdetails',
                      meta: {
                        name: '审核详情',
                        requestAuth: true,
                        acKey: 'proCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/rejectedList/auditdetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'proMaterialDiscount',
                  name: 'proMaterialDiscount',
                  meta: {
                    acKey: 'proCenter',
                    name: '商品折扣',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'proMaterialDiscountList'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/proMaterialDiscount/index'], resolve),
                  children: [
                    {
                      path: 'proMaterialDiscountList',
                      name: 'proMaterialDiscountList',
                      meta: {
                        acKey: 'proCenter',
                        name: '商品折扣设置',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/proMaterialDiscount/proMaterialDiscountList'], resolve),
                    }
                  ]
                },
                {
                  path: 'packegProSpu',
                  name: 'packegProSpu',
                  meta: {
                    acKey: 'proCenter',
                    name: '套餐商品',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'packegProSpuList'
                  },
                  component: resolve => require(['views/pages/proCenter/proManager/packegProSpu/index'], resolve),
                  children: [
                    {
                      path: 'packegProSpuList',
                      name: 'packegProSpuList',
                      meta: {
                        acKey: 'proCenter',
                        name: '套餐商品设置',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/packegProSpu/packegProSpuList'], resolve),
                    },
                    {
                      path: 'packegProSpuAdd',
                      name: 'packegProSpuAdd',
                      meta: {
                        acKey: 'proCenter',
                        name: '新增套餐商品',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/packegProSpu/packegProSpuAdd'], resolve),
                    },
                    {
                      path: 'packegProSpuEdit',
                      name: 'packegProSpuEdit',
                      meta: {
                        acKey: 'proCenter',
                        name: '编辑套餐商品',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/proCenter/proManager/packegProSpu/packegProSpuEdit'], resolve),
                    }
                  ]
                }
              ]
            },
            {
              path: 'proLog',
              name: 'proLog',
              meta: {
                name: '商品日志',
                requestAuth: true
              },
              redirect: {
                name: 'proCenterIndex'
              },
              component: resolve => require(['views/pages/proCenter/proLog/index'], resolve),
              children: [
                {
                  path: 'proLogList',
                  name: 'proLogList',
                  meta: {
                    name: '商品日志列表',
                    requestAuth: true,
                    acKey: 'proCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/proCenter/proLog/proLogList/proLogList'], resolve)
                }
              ]
            }
          ]
        },

        {
          path: 'promotionCenter',
          name: 'promotionCenter',
          meta: {
            name: '促销中心',
            requestAuth: true
          },
          redirect: {
            name: 'promotionCenterIndex'
          },
          component: resolve => require(['views/pages/promotionCenter/index'], resolve),
          children: [
            {
              path: 'promotionCenterIndex',
              name: 'promotionCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'promotionCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'promotionManager',
              name: 'promotionManager',
              meta: {
                name: '商户促销管理',
                requestAuth: true,
                acKey: 'promotionCenter'
              },
              redirect: {
                name: 'promotionCenterIndex'
              },
              component: resolve => require(['views/pages/promotionCenter/promotionManager/index'], resolve),
              children: [
                {
                  path: 'salesType',
                  name: 'salesType',
                  meta: {
                    name: '促销方式',
                    requestAuth: true,
                    acKey: 'promotionCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/promotionCenter/promotionManager/salesType/salesType'], resolve),
                },
              ]
            },
            {
              path: 'salesPromotion',
              name: 'salesPromotion',
              meta: {
                name: '促销管理',
                requestAuth: true
              },
              redirect: {
                name: 'promotionCenterIndex'
              },
              component: resolve => require(['views/pages/promotionCenter/salesPromotion/index'], resolve),
              children: [
                {
                  path: 'coupon',
                  name: 'coupon',
                  meta: {
                    name: '优惠券',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'coupons'
                  },
                  component: resolve => require(['views/pages/promotionCenter/salesPromotion/coupon/index'], resolve),
                  children: [
                    {
                      path: 'coupon',
                      name: 'coupons',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/salesPromotion/coupon/coupon'], resolve)
                    },
                    {
                      path: 'couponEdit',
                      name: 'couponEdit',
                      meta: {
                        name: '添加优惠券',
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/salesPromotion/coupon/couponEdit'], resolve)
                    },
                    {
                      path: 'couponView',
                      name: 'couponView',
                      meta: {
                        name: '查看优惠券',
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/salesPromotion/coupon/couponView'], resolve)
                    }
                  ]
                },
                {
                  path: 'couponUserList',
                  name: 'couponUserList',
                  meta: {
                    requestAuth: true,
                    name: '用户持有优惠券'
                  },
                  redirect: {
                    name: 'couponUserList_s'
                  },
                  component: resolve => require(['views/pages/promotionCenter/couponManager/couponUserList/index'], resolve),
                  children: [
                    {
                      path: 'couponUserList_s',
                      name: 'couponUserList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        pageFlag: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/couponManager/couponUserList/couponUserList_s'], resolve)
                    },
                    {
                      path: 'couponUserList_details',
                      name: 'couponUserList_details',
                      meta: {
                        name: '详情',
                        requestAuth: true,
                        acKey: 'promotionCenter'
                      },
                      component: resolve => require(['views/pages/promotionCenter/couponManager/couponUserList/couponUserList_details/couponUserList_details'], resolve)
                    }
                  ]
                },
                {
                  path: 'couponSendList',
                  name: 'couponSendList',
                  meta: {
                    name: '优惠券记录',
                    requestAuth: true,
                    acKey: 'promotionCenter',
                    pageFlag: 3
                  },
                  component: resolve => require(['views/pages/promotionCenter/couponManager/couponSendList/couponSendList'], resolve)
                },
                {
                  path: 'flashsaleList',
                  name: 'flashsaleList',
                  meta: {
                    name: '限时抢购列表',
                    requestAuth: true,
                    acKey: 'promotionCenter',
                    pageFlag: 3
                  },
                  component: resolve => require(['views/pages/promotionCenter/salesManager/flashsaleList/flashsaleList'], resolve)
                },
                {
                  path: 'addFlashsale',
                  name: 'addFlashsale',
                  title: '限时抢购新增',
                  meta: {
                    breadTitle: '限时抢购新增',
                    level: 4,
                    requestAuth: true,
                    acKey: 'promotionCenter'
                  },
                  component: resolve => require(['views/pages/promotionCenter/salesManager/flashsaleList/addFlashsale'], resolve)
                },
                {
                  path: 'editFlashsale',
                  name: 'editFlashsale',
                  title: '限时抢购编辑',
                  meta: {
                    breadTitle: '限时抢购编辑',
                    level: 4,
                    requestAuth: true,
                    acKey: 'promotionCenter'
                  },
                  component: resolve => require(['views/pages/promotionCenter/salesManager/flashsaleList/editFlashsale'], resolve)
                },
                {
                  path: 'detailsFlashsale',
                  name: 'detailsFlashsale',
                  title: '限时抢购详情',
                  meta: {
                    breadTitle: '限时抢购详情',
                    level: 4,
                    requestAuth: true,
                    acKey: 'promotionCenter'
                  },
                  component: resolve => require(['views/pages/promotionCenter/salesManager/flashsaleList/detailsFlashsale'], resolve)
                },
              ]
            },
            {
              path: 'score',
              name: 'score',
              meta: {
                name: '积分商城',
                requestAuth: true,
                acKey: 'promotionCenter'
              },
              redirect: {
                name: 'promotionCenterIndex'
              },
              component: resolve => require(['views/pages/promotionCenter/score/index'], resolve),
              children: [
                {
                  path: 'proCategory',
                  name: 'proCategory',
                  meta: {
                    name: '积分商品类别',
                    requestAuth: true,
                    acKey: 'promotionCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'proCategorys'
                  },
                  component: resolve => require(['views/pages/promotionCenter/score/proCategory/index'], resolve),
                  children: [
                    {
                      path: 'proCategorys',
                      name: 'proCategorys',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/score/proCategory/proCategory'], resolve)
                    }
                  ]
                },
                {
                  path: 'proList',
                  name: 'proList',
                  meta: {
                    name: '积分商品管理',
                    requestAuth: true,
                    acKey: 'promotionCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'proLists'
                  },
                  component: resolve => require(['views/pages/promotionCenter/score/proList/index'], resolve),
                  children: [
                    {
                      path: 'proLists',
                      name: 'proLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/score/proList/proList'], resolve)
                    }
                  ]
                },
                {
                  path: 'orderList',
                  name: 'orderList',
                  meta: {
                    name: '积分订单管理',
                    requestAuth: true,
                    acKey: 'promotionCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'orderLists'
                  },
                  component: resolve => require(['views/pages/promotionCenter/score/orderList/index'], resolve),
                  children: [
                    {
                      path: 'orderLists',
                      name: 'orderLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/score/orderList/orderList'], resolve)
                    },
                    {
                      path: 'orderDetails',
                      name: 'orderDetails',
                      meta: {
                        name: '订单详情',
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/score/orderList/orderListDetails'], resolve)
                    }

                  ]
                }
              ]
            },
            {
              path: 'groupManager',
              name: 'groupManager',
              meta: {
                name: '拼团管理',
                requestAuth: true
              },
              redirect: {
                name: 'promotionCenterIndex'
              },
              component: resolve => require(['views/pages/promotionCenter/groupManager/index'], resolve),
              children: [
                {
                  path: 'groupPro',
                  name: 'groupPro',
                  meta: {
                    name: '拼团商品',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'groupPros'
                  },
                  component: resolve => require(['views/pages/promotionCenter/groupManager/groupPro/index'], resolve),
                  children: [
                    {
                      path: 'groupPro',
                      name: 'groupPros',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/groupManager/groupPro/groupProList'], resolve)
                    },
                    {
                      path: 'groupProEdit',
                      name: 'groupProEdit',
                      meta: {
                        name: '编辑商品',
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/groupManager/groupPro/groupProEdit'], resolve)
                    },
                    {
                      path: 'groupProAdd',
                      name: 'groupProAdd',
                      meta: {
                        name: '新增商品',
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/groupManager/groupPro/groupProAdd'], resolve)
                    },
                    {
                      path: 'groupProView',
                      name: 'groupProView',
                      meta: {
                        name: '查看商品',
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/groupManager/groupPro/groupProView'], resolve)
                    }
                  ]
                },
                {
                  path: 'groupList',
                  name: 'groupList',
                  meta: {
                    name: '拼团列表',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'groupLists'
                  },
                  component: resolve => require(['views/pages/promotionCenter/groupManager/groupList/index'], resolve),
                  children: [
                    {
                      path: 'groupList',
                      name: 'groupLists',
                      meta: {
                        requestAuth: true,
                        acKey: 'promotionCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/promotionCenter/groupManager/groupList/groupList'], resolve)
                    },
                  ]
                }
              ]
            }
          ],
        },
        {
          path: 'cusOrderCenter',
          name: 'cusOrderCenter',
          meta: {
            requestAuth: true,
            name: '订单中心'
          },
          redirect: {
            name: 'cusOrderCenterIndex'
          },
          component: resolve => require(['views/pages/cusOrderCenter/index'], resolve),
          children: [
            {
              path: 'cusOrderCenterIndex',
              name: 'cusOrderCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'cusOrderCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve),
            },
            {
              path: 'cusOrderManager',
              name: 'cusOrderManager',
              meta: {
                requestAuth: true,
                name: '订单管理'
              },
              component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/index'], resolve),
              children: [
                {
                  path: 'advanceOrder',
                  name: 'advanceOrder',
                  meta: {
                    acKey: 'cusOrderCenter',
                    name: '意向单',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'advanceOrderList'
                  },
                  component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/advanceOrder/index'], resolve),
                  children: [
                    {
                      path: 'advanceOrderList',
                      name: 'advanceOrderList',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '意向单列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/advanceOrder/advanceOrderList'], resolve),
                    },
                    {
                      path: 'advanceOrderAdd',
                      name: 'advanceOrderAdd',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '新增意向单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/advanceOrder/advanceOrderAdd'], resolve),
                    },
                    {
                      path: 'advanceOrderEdit',
                      name: 'advanceOrderEdit',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '编辑意向单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/advanceOrder/advanceOrderEdit'], resolve),
                    },
                    {
                      path: 'advanceOrderView',
                      name: 'advanceOrderView',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '查看意向单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/advanceOrder/advanceOrderView'], resolve),
                    }
                  ]
                },
                {
                  path: 'contractOrder',
                  name: 'contractOrder',
                  meta: {
                    acKey: 'cusOrderCenter',
                    name: '合同订单',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'contractOrderList'
                  },
                  component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/index'], resolve),
                  children: [
                    {
                      path: 'contractOrderList',
                      name: 'contractOrderList',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '合同订单列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderList'], resolve),
                    },
                    {
                      path: 'contractOrderAdd',
                      name: 'contractOrderAdd',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '新增合同订单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderAdd'], resolve),
                    },
                    {
                      path: 'contractOrderEdit',
                      name: 'contractOrderEdit',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '编辑合同订单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderEdit'], resolve),
                    },
                    {
                      path: 'contractOrderView',
                      name: 'contractOrderView',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '查看合同订单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderView'], resolve),
                    },
                    {
                      path: 'contractOrderUpload',
                      name: 'contractOrderUpload',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '上传合同',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderUpload'], resolve),
                    },
                    {
                      path: 'contractOrderCollected',
                      name: 'contractOrderCollected',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '新增收款',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderCollected'], resolve),
                    },
                    {
                      path: 'contractOrderDelivery',
                      name: 'contractOrderDelivery',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '发货',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrder/contractOrderDelivery'], resolve),
                    }
                  ]
                },
                {
                  path: 'shipOrder',
                  name: 'shipOrder',
                  meta: {
                    acKey: 'cusOrderCenter',
                    name: '发货单',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'shipOrderList'
                  },
                  component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/shipOrder/index'], resolve),
                  children: [
                    {
                      path: 'shipOrderList',
                      name: 'shipOrderList',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '发货单单列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/shipOrder/shipOrderList'], resolve),
                    },
                    {
                      path: 'shipOrderView',
                      name: 'shipOrderView',
                      meta: {
                        acKey: 'cusOrderCenter',
                        name: '查看发货单单',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/shipOrder/shipOrderView'], resolve),
                    }
                  ]
                },
                {
                  path: 'contractOrderReply',
                  name: 'contractOrderReply',
                  meta: {
                    name: '合同订单评价',
                    requestAuth: true,
                    acKey: 'cusOrderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'contractOrderReplyList'
                  },
                  component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrderReply/index'], resolve),
                  children: [
                    {
                      path: 'contractOrderReplyList',
                      name: 'contractOrderReplyList',
                      meta: {
                        requestAuth: true,
                        acKey: 'cusOrderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/cusOrderCenter/cusOrderManager/contractOrderReply/contractOrderReplyList'], resolve)
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'orderCenter',
          name: 'orderCenter',
          meta: {
            name: '订单中心Old',
            requestAuth: true
          },
          redirect: {
            name: 'orderCenterIndex'
          },
          component: resolve => require(['views/pages/orderCenter/index'], resolve),
          children: [
            {
              path: 'orderCenterIndex',
              name: 'orderCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'orderCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'orderManager',
              name: 'orderManager',
              meta: {
                name: '销售管理',
                requestAuth: true,
                acKey: 'orderCenter'
              },
              redirect: {
                name: 'orderCenterIndex'
              },
              component: resolve => require(['views/pages/orderCenter/orderManager/index'], resolve),
              children: [
                {
                  path: 'orderList',
                  name: 'orderList',
                  meta: {
                    name: '销售订单',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'orderList_s'
                  },
                  component: resolve => require(['views/pages/orderCenter/orderManager/orderList/index'], resolve),
                  children: [
                    {
                      path: 'orderList_s',
                      name: 'orderList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderList/orderList_s'], resolve)
                    },
                    {
                      path: 'orderListDetails',
                      name: 'orderListDetails',
                      meta: {
                        name: '订单详情',
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderList/orderListDetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'canceledOrderList',
                  name: 'canceledOrderList',
                  meta: {
                    name: '已取消销售订单',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'canceledOrderList_s'
                  },
                  component: resolve => require(['views/pages/orderCenter/orderManager/canceledOrderList/index'], resolve),
                  children: [
                    {
                      path: 'canceledOrderList_s',
                      name: 'canceledOrderList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/canceledOrderList/canceledOrderList_s'], resolve)
                    },
                    {
                      path: 'canceledOrderListDetails',
                      name: 'canceledOrderListDetails',
                      meta: {
                        name: '已取消点单详情',
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/canceledOrderList/canceledOrderListDetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'orderPrintList',
                  name: 'orderPrintList',
                  meta: {
                    name: '订单打印发货',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'orderPrintList_s'
                  },
                  component: resolve => require(['views/pages/orderCenter/orderManager/orderPrintList/index'], resolve),
                  children: [
                    {
                      path: 'orderPrintList_s',
                      name: 'orderPrintList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderPrintList/orderPrintList'], resolve)
                    },
                    {
                      path: 'orderListDetails',
                      name: 'orderListDetails',
                      meta: {
                        name: '订单详情',
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderPrintList/orderListDetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'orderProcessingList',
                  name: 'orderProcessingList',
                  meta: {
                    name: '订单处理',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'orderProcessingList_s'
                  },
                  component: resolve => require(['views/pages/orderCenter/orderManager/orderProcessingList/index'], resolve),
                  children: [
                    {
                      path: 'orderProcessingList_s',
                      name: 'orderProcessingList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderProcessingList/orderProcessingList'], resolve)
                    },
                    {
                      path: 'orderListDetails',
                      name: 'orderListDetails',
                      meta: {
                        name: '订单详情',
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderProcessingList/orderListDetails'], resolve)
                    }
                  ]
                },
                {
                  path: 'orderVerificationList',
                  name: 'orderVerificationList',
                  meta: {
                    name: '订单核销',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'orderVerificationList'
                  },
                  component: resolve => require(['views/pages/orderCenter/orderManager/orderVerification/index'], resolve),
                  children: [
                    {
                      path: 'orderVerificationList',
                      name: 'orderVerificationList',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/orderVerification/orderVerificationList'], resolve)
                    }
                  ]
                },
                {
                  path: 'venProSpuReply',
                  name: 'venProSpuReply',
                  meta: {
                    name: '订单评价',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'venProSpuReplyList'
                  },
                  component: resolve => require(['views/pages/orderCenter/orderManager/venProSpuReply/index'], resolve),
                  children: [
                    {
                      path: 'venProSpuReplyList',
                      name: 'venProSpuReplyList',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderManager/venProSpuReply/venProSpuReplyList'], resolve)
                    }
                  ]
                }
              ]
            },
            {
              path: 'orderRpt',
              name: 'orderRpt',
              meta: {
                name: '销售统计',
                requestAuth: true,
                acKey: 'orderCenter'
              },
              redirect: {name: 'orderCenterIndex'},
              component: resolve => require(['views/pages/orderCenter/orderRpt/index'], resolve),
              children:[
                {
                  path: 'rptList',
                  name: 'rptList',
                  meta: {
                    name: '社区销售统计',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {name: 'sqxstj'},
                  component: resolve => require(['views/pages/orderCenter/orderRpt/rptList/index'], resolve),
                  children: [
                    {
                      path: 'sqxstj',
                      name: 'sqxstj',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderRpt/rptList/sqxstj'], resolve)
                    }
                  ]
                },
                {
                  path: 'mlbList',
                  name: 'mlbList',
                  meta: {
                    name: '毛利表',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {name: 'mlb'},
                  component: resolve => require(['views/pages/orderCenter/orderRpt/mlbList/index'], resolve),
                  children: [
                    {
                      path: 'mlb',
                      name: 'mlb',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderRpt/mlbList/mlb'], resolve)
                    }
                  ]
                },
                {
                  path: 'yongjinoneList',
                  name: 'yongjinoneList',
                  meta: {
                    name: '佣金统计1',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {name: 'yjtjone'},
                  component: resolve => require(['views/pages/orderCenter/orderRpt/yongjinoneList/index'], resolve),
                  children: [
                    {
                      path: 'yjtjone',
                      name: 'yjtjone',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderRpt/yongjinoneList/yjtjone'], resolve)
                    }
                  ]
                },
                {
                  path: 'yongjintwoList',
                  name: 'yongjintwoList',
                  meta: {
                    name: '佣金统计2',
                    requestAuth: true,
                    acKey: 'orderCenter',
                    level: 3
                  },
                  redirect: {name: 'yjtjtwo'},
                  component: resolve => require(['views/pages/orderCenter/orderRpt/yongjintwoList/index'], resolve),
                  children: [
                    {
                      path: 'yjtjtwo',
                      name: 'yjtjtwo',
                      meta: {
                        requestAuth: true,
                        acKey: 'orderCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/orderCenter/orderRpt/yongjintwoList/yjtjtwo'], resolve)
                    }
                  ]
                },
              ]
            }
          ]
        },
        {
          path: 'memberCenter',
          name: 'memberCenter',
          meta: {
            name: '会员中心',
            requestAuth: true
          },
          redirect: {
            name: 'memberCenterIndex'
          },
          component: resolve => require(['views/pages/memberCenter/index'], resolve),
          children: [
            {
              path: 'memberCenterIndex',
              name: 'memberCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'memberCenter',
                pageFlag: 1
              },
              // component: resolve => require(['views/pages/memberCenter/memberCenterIndex/memberCenterIndex'], resolve)
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'memberManager',
              name: 'memberManager',
              meta: {
                name: '会员管理',
                requestAuth: true,
                acKey: 'memberCenter'
              },
              redirect: {
                name: 'memberCenterIndex'
              },
              component: resolve => require(['views/pages/memberCenter/memberManager/index'], resolve),
              children: [
                {
                  path: 'memberList',
                  name: 'memberList',
                  meta: {
                    name: '会员列表',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberList_s'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberList/index'], resolve),
                  children: [
                    {
                      path: 'memberList_s',
                      name: 'memberList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberList/memberList_s'], resolve)
                    },
                    {
                      path: 'promoteInformation',
                      name: 'promoteInformation',
                      meta: {
                        name: '推广明细',
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/paymentCenter/basicManagement/memberInformation/promoteInformation'], resolve)
                    },
                  ]
                },
                {
                  path: 'memberTypeList',
                  name: 'memberTypeList',
                  meta: {
                    name: '会员类别',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberTypeList_s'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberTypeList/index'], resolve),
                  children: [
                    {
                      path: 'memberTypeList_s',
                      name: 'memberTypeList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberTypeList/memberTypeList_s'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberLevelList',
                  name: 'memberLevelList',
                  meta: {
                    name: '会员等级',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberLevelList_s'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberLevelList/index'], resolve),
                  children: [
                    {
                      path: 'memberLevelList_s',
                      name: 'memberLevelList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberLevelList/memberLevelList_s'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberFeedback',
                  name: 'memberFeedback',
                  meta: {
                    name: '意见反馈',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberFeedbackList'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberFeedback/index'], resolve),
                  children: [
                    {
                      path: 'memberFeedbackList',
                      name: 'memberFeedbackList',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberFeedback/memberFeedbackList'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberAddress',
                  name: 'memberAddress',
                  meta: {
                    name: '收货地址',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberAddressList'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberAddress/index'], resolve),
                  children: [
                    {
                      path: 'memberAddressList',
                      name: 'memberAddressList',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberAddress/memberAddressList'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberCollection',
                  name: 'memberCollection',
                  meta: {
                    name: '用户收藏',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberCollectionList'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberCollection/index'], resolve),
                  children: [
                    {
                      path: 'memberCollectionList',
                      name: 'memberCollectionList',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberCollection/memberCollectionList'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberIntegral',
                  name: 'memberIntegral',
                  meta: {
                    name: '用户积分',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberIntegralList'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberIntegral/index'], resolve),
                  children: [
                    {
                      path: 'memberIntegralList',
                      name: 'memberIntegralList',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberIntegral/memberIntegralList'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberBrowse',
                  name: 'memberBrowse',
                  meta: {
                    name: '浏览记录',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberBrowseList'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberBrowse/index'], resolve),
                  children: [
                    {
                      path: 'memberBrowseList',
                      name: 'memberBrowseList',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberBrowse/memberBrowseList'], resolve)
                    }
                  ]
                },
                {
                  path: 'memberSignSet',
                  name: 'memberSignSet',
                  meta: {
                    name: '签到设置',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberSignSetList'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberManager/memberSignSet/index'], resolve),
                  children: [
                    {
                      path: 'memberSignSetList',
                      name: 'memberSignSetList',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberManager/memberSignSet/memberSignSetList'], resolve)
                    }
                  ]
                }
              ]
            },
            {
              path: 'customerManager',
              name: 'customerManager',
              meta: {
                requestAuth: true,
                name: '客户管理'
              },
              component: resolve => require(['views/pages/memberCenter/customerManager/index'], resolve),
              children: [
                {
                  path: 'customer',
                  name: 'customer',
                  meta: {
                    acKey: 'memberCenter',
                    name: '客户',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'customerList'
                  },
                  component: resolve => require(['views/pages/memberCenter/customerManager/customer/index'], resolve),
                  children: [
                    {
                      path: 'customerList',
                      name: 'customerList',
                      meta: {
                        acKey: 'memberCenter',
                        name: '客户列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/memberCenter/customerManager/customer/customerList'], resolve),
                    }
                  ]
                },
                {
                  path: 'cusFollowRecord',
                  name: 'cusFollowRecord',
                  meta: {
                    acKey: 'memberCenter',
                    name: '客户跟进',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'cusFollowRecordList'
                  },
                  component: resolve => require(['views/pages/memberCenter/customerManager/cusFollowRecord/index'], resolve),
                  children: [
                    {
                      path: 'cusFollowRecordList',
                      name: 'cusFollowRecordList',
                      meta: {
                        acKey: 'memberCenter',
                        name: '客户跟进列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/memberCenter/customerManager/cusFollowRecord/cusFollowRecordList'], resolve),
                    }
                  ]
                },
                {
                  path: 'cusReceptionRecord',
                  name: 'cusReceptionRecord',
                  meta: {
                    acKey: 'memberCenter',
                    name: '客户接待',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'cusReceptionRecordList'
                  },
                  component: resolve => require(['views/pages/memberCenter/customerManager/cusReceptionRecord/index'], resolve),
                  children: [
                    {
                      path: 'cusReceptionRecordList',
                      name: 'cusReceptionRecordList',
                      meta: {
                        acKey: 'memberCenter',
                        name: '客户接待列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/memberCenter/customerManager/cusReceptionRecord/cusReceptionRecordList'], resolve),
                    }
                  ]
                }
              ]
            },
            {
              path: 'memberLogManager',
              name: 'memberLogManager',
              meta: {
                name: '日志管理',
                requestAuth: true,
                acKey: 'memberCenter'
              },
              redirect: {
                name: 'memberCenterIndex'
              },
              component: resolve => require(['views/pages/memberCenter/memberLogManager/index'], resolve),
              children: [
                {
                  path: 'memberLogList',
                  name: 'memberLogList',
                  meta: {
                    name: '会员日志',
                    requestAuth: true
                  },
                  redirect: {
                    name: 'memberLogList_s'
                  },
                  component: resolve => require(['views/pages/memberCenter/memberLogManager/memberLogList/index'], resolve),
                  children: [
                    {
                      path: 'memberLogList_s',
                      name: 'memberLogList_s',
                      meta: {
                        requestAuth: true,
                        acKey: 'memberCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/memberCenter/memberLogManager/memberLogList/memberLogList_s'], resolve)
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'systemCenter',
          name: 'systemCenter',
          meta: {
            name: '系统中心',
            requestAuth: true
          },
          redirect: {
            name: 'systemCenterIndex'
          },
          component: resolve => require(['views/pages/systemCenter/index'], resolve),
          children: [
            {
              path: 'systemCenterIndex',
              name: 'systemCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'systemCenter',
                pageFlag: 1
              },
              // component: resolve => require(['views/pages/systemCenter/systemCenterIndex/systemCenterIndex'], resolve)
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'userRoleManager',
              name: 'userRoleManager',
              meta: {
                name: '用户角色管理',
                requestAuth: true,
                acKey: 'systemCenter'
              },
              redirect: {
                name: 'systemCenterIndex'
              },
              component: resolve => require(['views/pages/systemCenter/userManager/index'], resolve),
              children: [
                {
                  path: 'sysUserList',
                  name: 'sysUserList',
                  meta: {
                    name: '用户列表',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/userManager/sysUserList/sysUserList'], resolve)
                },
                {
                  path: 'sysRoleList',
                  name: 'sysRoleList',
                  meta: {
                    name: '角色列表',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/roleManager/sysRoleList/sysRoleList'], resolve)
                },
                {
                  path: 'actionList',
                  name: 'actionList',
                  meta: {
                    name: '资源列表',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/actionManager/actionList/actionList'], resolve)
                }
              ]
            },
            {
              path: 'setManager',
              name: 'setManager',
              meta: {
                name: '设置管理',
                requestAuth: true,
                acKey: 'systemCenter'
              },
              redirect: {
                name: 'systemCenterIndex'
              },
              component: resolve => require(['views/pages/systemCenter/setManager/index'], resolve),
              children: [
                {
                  path: 'baseshopSetting',
                  name: 'baseshopSetting',
                  meta: {
                    name: '基础设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/baseshopSetting/baseshopSetting_s'], resolve)
                },
                {
                  path: 'baseLogoSetting',
                  name: 'baseLogoSetting',
                  meta: {
                    name: '基础设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/baseLogoSetting/baseLogoSetting'], resolve)
                },
                {
                  path: 'paymentSetting',
                  name: 'paymentSetting',
                  meta: {
                    name: '支付设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/paymentSetting/paymentSetting_s'], resolve)
                },
                {
                  path: 'wxBaseInfo',
                  name: 'wxBaseInfo',
                  meta: {
                    name: '公众号设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/wxBaseInfo/wxBaseInfo'], resolve)
                },
                {
                  path: 'withdrawalSetting',
                  name: 'withdrawalSetting',
                  meta: {
                    name: '余额提现设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/withdrawalSetting/withdrawalSetting_s'], resolve)
                },
                {
                  path: 'ossInfoSetting',
                  name: 'ossInfoSetting',
                  meta: {
                    name: '七牛OSS设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/ossInfoSetting/ossInfoSetting_s'], resolve)
                },
                {
                  path: 'groupTimeSetting',
                  name: 'groupTimeSetting',
                  meta: {
                    name: '开团时间设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/groupTime/groupTimeSettingList'], resolve)
                },
                {
                  path: 'pickingTime',
                  name: 'pickingTime',
                  meta: {
                    name: '取货时间设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/pickingTime/pickingTimeList'], resolve)
                },
                {
                  path: 'physicalStore',
                  name: 'physicalStore',
                  meta: {
                    name: '门店设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/physicalStore/physicalStoreList'], resolve)
                },
                {
                  path: 'PhysicalStoreAdd',
                  name: 'PhysicalStoreAdd',
                  meta: {
                    name: '新增门店',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/physicalStore/physicalStoreAdd'], resolve)
                },
                {
                  path: 'PhysicalStoreEdit',
                  name: 'PhysicalStoreEdit',
                  meta: {
                    name: '编辑门店',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/physicalStore/physicalStoreEdit'], resolve)
                },
                {
                  path: 'wxSubscribe',
                  name: 'wxSubscribe',
                  meta: {
                    name: '小程序订阅消息',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/wxSubscribe/wxSubscribeList'], resolve)
                },
                {
                  path: 'wxSubscribeAdd',
                  name: 'wxSubscribeAdd',
                  meta: {
                    name: '新增订阅消息',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/wxSubscribe/wxSubscribeAdd'], resolve)
                },
                {
                  path: 'wxSubscribeEdit',
                  name: 'wxSubscribeEdit',
                  meta: {
                    name: '编辑订阅消息',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/wxSubscribe/wxSubscribeEdit'], resolve)
                },
                {
                  path: 'areaList',
                  name: 'areaList',
                  meta: {
                    name: '省市区管理',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/areaManager/areaList'], resolve)
                },
                {
                  path: 'areaAdd',
                  name: 'areaAdd',
                  meta: {
                    name: '新增省市区',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/areaManager/areaAdd'], resolve)
                },
                {
                  path: 'areaEdit',
                  name: 'areaEdit',
                  meta: {
                    name: '编辑省市区',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/setManager/areaManager/areaEdit'], resolve)
                },

              ]
            },
            {
              path: 'wxRealtion',
              name: 'wxRealtion',
              meta: {
                name: '微信公众号',
                requestAuth: true,
                acKey: 'systemCenter'
              },
              redirect: {
                name: 'systemCenterIndex'
              },
              component: resolve => require(['views/pages/systemCenter/wxRealtion/index'], resolve),
              children:[
                {
                  path: 'wxMenu',
                  name: 'wxMenu',
                  meta: {
                    name: '微信菜单',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/wxMenu/wxMenuList'], resolve)
                },
                {
                  path: 'wxMenuAdd',
                  name: 'wxMenuAdd',
                  meta: {
                    name: '新增微信菜单',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/wxMenu/wxMenuAdd'], resolve)
                },
                {
                  path: 'wxMenuEdit',
                  name: 'wxMenuEdit',
                  meta: {
                    name: '编辑微信菜单',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/wxMenu/wxMenuEdit'], resolve)
                },
                {
                  path: 'followReplay',
                  name: 'followReplay',
                  meta: {
                    name: '关注回复',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/followReplay'], resolve)
                },
                {
                  path: 'invalidReplay',
                  name: 'invalidReplay',
                  meta: {
                    name: '无效关键字回复',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/invalidReplay'], resolve)
                },
                {
                  path: 'keywordReplay',
                  name: 'keywordReplay',
                  meta: {
                    name: '关键字回复',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/keywordReplay/keyWordReplayList'], resolve)
                },
                {
                  path: 'keyWordReplayAdd',
                  name: 'keyWordReplayAdd',
                  meta: {
                    name: '新增关键字回复',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/keywordReplay/keyWordReplayAdd'], resolve)
                },
                {
                  path: 'keyWordReplayEdit',
                  name: 'keyWordReplayEdit',
                  meta: {
                    name: '编辑关键字回复',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/wxRealtion/keywordReplay/keyWordReplayEdit'], resolve)
                },
              ]
            },
            {
              path: 'sysLogManager',
              name: 'sysLogManager',
              meta: {
                name: '日志管理',
                requestAuth: true,
                acKey: 'systemCenter'
              },
              redirect: {
                name: 'systemCenterIndex'
              },
              component: resolve => require(['views/pages/systemCenter/sysLogManager/index'], resolve),
              children:[
                {
                  path: 'sysOperLog',
                  name: 'sysOperLog',
                  meta: {
                    name: '操作日志',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/sysLogManager/sysOperLog/sysOperLogList'], resolve)
                },
              ]
            },
            {
              path: 'sysLogManager',
              name: 'sysLogManager',
              meta: {
                name: '日志管理',
                requestAuth: true,
                acKey: 'systemCenter'
              },
              redirect: {
                name: 'systemCenterIndex'
              },
              component: resolve => require(['views/pages/systemCenter/loginManager/index'], resolve),
              children:[
                {
                  path: 'loginList',
                  name: 'loginList',
                  meta: {
                    name: '登录日志',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/loginManager/loginList/loginList'], resolve)
                },
              ]
            },
            {
              path: 'infoManager',
              name: 'infoManager',
              meta: {
                name: '信息管理',
                requestAuth: true,
                acKey: 'systemCenter'
              },
              redirect: {
                name: 'systemCenterIndex'
              },
              component: resolve => require(['views/pages/systemCenter/infoManager/index'], resolve),
              children: [
                {
                  path: 'xcxNavBtnList',
                  name: 'xcxNavBtnList',
                  meta: {
                    name: '小程序菜单数据',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/xcxNavBtn/xcxNavBtnList'], resolve)
                },
                {
                  path: 'cmsArticleCategoryList',
                  name: 'cmsArticleCategoryList',
                  meta: {
                    name: '公告类别',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsArticleCategory/cmsArticleCategoryList'], resolve)
                },
                {
                  path: 'cmsArticleList',
                  name: 'cmsArticleList',
                  meta: {
                    name: '公司公告',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsArticle/cmsArticleList'], resolve)
                },
                {
                  path: 'cmsArticleAdd',
                  name: 'cmsArticleAdd',
                  meta: {
                    name: '添加',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsArticle/cmsArticleAdd'], resolve)
                },
                {
                  path: 'cmsArticleEdit',
                  name: 'cmsArticleEdit',
                  meta: {
                    name: '编辑',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsArticle/cmsArticleEdit'], resolve)
                },
                {
                  path: 'cmsKnowledgeCategoryList',
                  name: 'cmsKnowledgeCategoryList',
                  meta: {
                    name: '知识类别',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsKnowledgeCategory/cmsKnowledgeCategoryList'], resolve)
                },
                {
                  path: 'cmsKnowledgeList',
                  name: 'cmsKnowledgeList',
                  meta: {
                    name: '知识管理',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsKnowledge/cmsKnowledgeList'], resolve)
                },
                {
                  path: 'cmsKnowledgeAdd',
                  name: 'cmsKnowledgeAdd',
                  meta: {
                    name: '添加',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsKnowledge/cmsKnowledgeAdd'], resolve)
                },
                {
                  path: 'cmsKnowledgeEdit',
                  name: 'cmsKnowledgeEdit',
                  meta: {
                    name: '编辑',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/cmsKnowledge/cmsKnowledgeEdit'], resolve)
                },
                {
                  path: 'companySetting',
                  name: 'companySetting',
                  meta: {
                    name: '公司介绍设置',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/companySetting/companySetting_s'], resolve)
                },
                {
                  path: 'xcxModuleList',
                  name: 'xcxModuleList',
                  meta: {
                    name: '首页模块',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/xcxModule/xcxModuleList'], resolve)
                },
                {
                  path: 'xcxModuleAdd',
                  name: 'xcxModuleAdd',
                  meta: {
                    name: '添加',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/xcxModule/xcxModuleAdd'], resolve)
                },
                {
                  path: 'xcxModuleEdit',
                  name: 'xcxModuleEdit',
                  meta: {
                    name: '编辑',
                    requestAuth: true,
                    acKey: 'systemCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/systemCenter/infoManager/xcxModule/xcxModuleEdit'], resolve)
                },

              ]
            }
          ]
        },
        {
          // 物流中心
          path: 'logisticsCenter',
          name: 'logisticsCenter',
          meta: {
            requestAuth: true,
            name: '物流中心'
          },
          redirect: {
            name: 'logisticsCenterIndex'
          },
          component: resolve => require(['views/pages/logisticsCenter/index'], resolve),
          children: [
            {
              path: 'logisticsCenterIndex',
              name: 'logisticsCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'logisticsCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve),
            },
            {
              path: 'freightManager',
              name: 'freightManager',
              meta: {
                requestAuth: true,
                name: '运费管理'
              },
              component: resolve => require(['views/pages/logisticsCenter/freightManager/index'], resolve),
              children: [
                {
                  path: 'freightTemplate',
                  name: 'freightTemplate',
                  meta: {
                    acKey: 'logisticsCenter',
                    name: '运费模板',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'templateList'
                  },
                  component: resolve => require(['views/pages/logisticsCenter/freightManager/freightTemplate/index'], resolve),
                  children: [
                    {
                      path: 'templateList',
                      name: 'templateList',
                      meta: {
                        acKey: 'logisticsCenter',
                        name: '模版列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/logisticsCenter/freightManager/freightTemplate/freightTemplate'], resolve),
                    },
                    {
                      path: 'newFreightTemplates',
                      name: 'newFreightTemplates',
                      meta: {
                        acKey: 'logisticsCenter',
                        name: '新增模版',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/logisticsCenter/freightManager/freightTemplate/newFreightTemplates'], resolve),
                    },
                    {
                      path: 'editorFreightTemplates',
                      name: 'editorFreightTemplates',
                      meta: {
                        acKey: 'logisticsCenter',
                        name: '修改模版',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/logisticsCenter/freightManager/freightTemplate/editorFreightTemplates'], resolve),
                    }
                  ]
                },
                {
                  path: 'deliveryCompany',
                  name: 'deliveryCompany',
                  meta: {
                    acKey: 'logisticsCenter',
                    name: '快递公司',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'deliveryCompanyList'
                  },
                  component: resolve => require(['views/pages/logisticsCenter/freightManager/deliveryCompany/index'], resolve),
                  children: [
                    {
                      path: 'deliveryCompanyList',
                      name: 'deliveryCompanyList',
                      meta: {
                        acKey: 'logisticsCenter',
                        name: '快递公司列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/logisticsCenter/freightManager/deliveryCompany/deliveryCompanyList'], resolve),
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          // 分销中心
          path: 'distributionCenter',
          name: 'distributionCenter',
          meta: {
            requestAuth: true,
            name: '分销中心'
          },
          redirect: {
            name: 'distributionCenterIndex'
          },
          component: resolve => require(['views/pages/distributionCenter/index'], resolve),
          children: [
            {
              path: 'distributionCenterIndex',
              name: 'distributionCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'distributionCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve),
            },
            {
              path: 'distributionManager',
              name: 'distributionManager',
              meta: {
                requestAuth: true,
                name: '分销管理'
              },
              component: resolve => require(['views/pages/distributionCenter/distributionManager/index'], resolve),
              children: [
                {
                  path: 'distributionList',
                  name: 'distributionList',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '基础设置',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionList/distributionList_s'], resolve),
                },
                {
                  path: 'distributionSettingLlineAdd',
                  name: 'distributionSettingLlineAdd',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '新增分佣规则',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionList/distributionSettingLlineAdd'], resolve),
                },
                {
                  path: 'distributionSettingLlineEdit',
                  name: 'distributionSettingLlineEdit',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '编辑分佣规则',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionList/distributionSettingLlineEdit'], resolve),
                },
                {
                  path: 'userCommission',
                  name: 'userCommission',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '佣金记录',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/userCommission/userCommissionList'], resolve),
                },
                {
                  path: 'commissionSettlement',
                  name: 'commissionSettlement',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '佣金结算',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/userCommission/commissionSettlement'], resolve),
                },
                {
                  path: 'distributionPerson',
                  name: 'distributionPerson',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '分销人员',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionPerson/distributionPersonList'], resolve),
                },
                {
                  path: 'userCommissionDetail',
                  name: 'userCommissionDetail',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '佣金详情',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/userCommission/userCommissionDetail'], resolve),
                },
                {
                  path: 'DistributionSpreadBanner',
                  name: 'DistributionSpreadBanner',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '分享海报',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionSpreadBanner/distributionSpreadBannerList'], resolve),
                },
                {
                  path: 'distributionSpreadBannerAdd',
                  name: 'distributionSpreadBannerAdd',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '新增海报',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionSpreadBanner/distributionSpreadBannerAdd'], resolve),
                },
                {
                  path: 'distributionSpreadBannerEdit',
                  name: 'distributionSpreadBannerEdit',
                  meta: {
                    acKey: 'distributionCenter',
                    name: '编辑海报',
                    requestAuth: true
                  },
                  component: resolve => require(['views/pages/distributionCenter/distributionManager/distributionSpreadBanner/distributionSpreadBannerEdit'], resolve),
                }
              ]
            }
          ]
        },
        {
          path: 'paymentCenter',
          name: 'paymentCenter',
          meta: {
            name: '支付中心',
            requestAuth: true
          },
          redirect: {
            name: 'paymentCenterIndex'
          },
          component: resolve => require(['views/pages/paymentCenter/index'], resolve),
          children: [
            {
              path: 'paymentCenterIndex',
              name: 'paymentCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'paymentCenter',
                pageFlag: 1
              },
              // component: resolve => require(['views/pages/financeCenter/financeCenterIndex/financeCenterIndex'], resolve)
              component: resolve => require(['views/pages/pageIndex'], resolve)
            },
            {
              path: 'paymentManagement',
              name: 'paymentManagement',
              meta: {
                name: '支付管理',
                requestAuth: true,
                acKey: 'paymentCenter'
              },
              redirect: {
                name: 'paymentCenterIndex'
              },
              component: resolve => require(['views/pages/paymentCenter/paymentManagement/index'], resolve),
              children: [
                {
                  path: 'paymentOrder',
                  name: 'paymentOrder',
                  meta: {
                    name: '支付订单',
                    requestAuth: true,
                    acKey: 'paymentCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/paymentCenter/paymentManagement/paymentOrder/paymentOrder'], resolve)
                },
                {
                  path: 'refundConfirmList',
                  name: 'refundConfirmList',
                  meta: {
                    name: '退款单列表',
                    requestAuth: true,
                    acKey: 'paymentCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/paymentCenter/refundConfirmManagement/refundConfirmList/refundConfirmList'], resolve)
                },
                {
                  path: 'payWithdrawals',
                  name: 'payWithdrawals',
                  meta: {
                    name: '提现申请',
                    requestAuth: true,
                    acKey: 'paymentCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/paymentCenter/paymentManagement/payWithdrawals/payWithdrawalsList'], resolve)
                }
              ]
            },
            {
              path: 'basicManagement',
              name: 'basicManagement',
              meta: {
                name: '基础信息设置',
                requestAuth: true,
                acKey: 'paymentCenter'
              },
              redirect: {
                name: 'paymentCenterIndex'
              },
              component: resolve => require(['views/pages/paymentCenter/basicManagement/index'], resolve),
              children: [
                {
                  path: 'cashier',
                  name: 'cashier',
                  meta: {
                    name: '收银台配置',
                    requestAuth: true,
                    acKey: 'paymentCenter',
                    level: 3
                  },
                  component: resolve => require(['views/pages/paymentCenter/basicManagement/cashier/cashier'], resolve)
                },
                {
                  path: 'memberInformation',
                  name: 'memberInformation',
                  meta: {
                    name: '会员信息',
                    requestAuth: true,
                    acKey: 'paymentCenter',
                    level: 3
                  },
                  redirect: {
                    name: 'memberInfo'
                  },
                  component: resolve => require(['views/pages/paymentCenter/basicManagement/memberInformation/index'], resolve),
                  children: [
                    {
                      path: 'memberInfo',
                      name: 'memberInfo',
                      meta: {
                        name: '',
                        requestAuth: true,
                        acKey: 'paymentCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/paymentCenter/basicManagement/memberInformation/memberInformation'], resolve)
                    },
                    {
                      path: 'tradingInformation',
                      name: 'tradingInformation',
                      meta: {
                        name: '交易明细',
                        requestAuth: true,
                        acKey: 'paymentCenter',
                        level: 3
                      },
                      component: resolve => require(['views/pages/paymentCenter/basicManagement/memberInformation/tradingInformation'], resolve)
                    },
                  ]
                },
              ]
            }
          ]
        },
        {
          // 员工中心
          path: 'salesmanCenter',
          name: 'salesmanCenter',
          meta: {
            requestAuth: true,
            name: '员工中心'
          },
          redirect: {
            name: 'salesmanCenterIndex'
          },
          component: resolve => require(['views/pages/salesmanCenter/index'], resolve),
          children: [
            {
              path: 'salesmanCenterIndex',
              name: 'salesmanCenterIndex',
              meta: {
                requestAuth: true,
                acKey: 'salesmanCenter',
                pageFlag: 1
              },
              component: resolve => require(['views/pages/pageIndex'], resolve),
            },
            {
              path: 'salesmanManager',
              name: 'salesmanManager',
              meta: {
                requestAuth: true,
                name: '员工管理'
              },
              component: resolve => require(['views/pages/salesmanCenter/salesmanManager/index'], resolve),
              children: [
                {
                  path: 'salesmanPosition',
                  name: 'salesmanPosition',
                  meta: {
                    acKey: 'salesmanCenter',
                    name: '员工职位',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'salesmanPositionList'
                  },
                  component: resolve => require(['views/pages/salesmanCenter/salesmanManager/salesmanPosition/index'], resolve),
                  children: [
                    {
                      path: 'salesmanPositionList',
                      name: 'salesmanPositionList',
                      meta: {
                        acKey: 'salesmanCenter',
                        name: '员工职位列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/salesmanCenter/salesmanManager/salesmanPosition/salesmanPositionList'], resolve),
                    }
                  ]
                },
                {
                  path: 'salesman',
                  name: 'salesman',
                  meta: {
                    acKey: 'salesmanCenter',
                    name: '员工',
                    requestAuth: true,
                    level: 3
                  },
                  redirect: {
                    name: 'salesmanList'
                  },
                  component: resolve => require(['views/pages/salesmanCenter/salesmanManager/salesman/index'], resolve),
                  children: [
                    {
                      path: 'salesmanList',
                      name: 'salesmanList',
                      meta: {
                        acKey: 'salesmanCenter',
                        name: '员工列表',
                        requestAuth: true
                      },
                      component: resolve => require(['views/pages/salesmanCenter/salesmanManager/salesman/salesmanList'], resolve),
                    }
                  ]
                }
              ]
            }
          ]
        },
      ]

    },
    {
      path: '*',
      name: 'p404',
      meta: {
        name: '404'
      },
      component: resolve => require(['views/404/index'], resolve)
    }

  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.requestAuth) {
    let nowCookie = getNowCookie();
    let userInfo = nowCookie.userInfo;
    if (userInfo) {
      next();
    } else {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

router.afterEach((to, from, next) => {
  NProgress.done();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js